/**
 * @description Formats API responses into normalized objects
 * @param {Boolean} ok - indicates whether or not the response was successful
 * @param {Number} status - the HTTP status code of the response
 * @param {String|null} message - the error message if extant, else null
 * @param {Object|null} data - the data object if extant, else null
 * @returns {Object} - formatted response object
 */
export default function ({ ok, status, message, data }) {
  return {
    ok,
    status,
    message,
    data
  };
}
